import { Injectable } from '@angular/core';
import { AuthRedirectService } from './auth-redirect.service';
import { environment } from 'apps/purchasing-portal/src/environments/environment';

const releaseUrlMap = {
  local: 'http://localhost:4200',
  canary: 'https://v3.asylumtix.com',
  stable: 'https://asylumtix.com',
  experimental: 'https://v2.asylumtix.com'
};

@Injectable()
export class ReleaseSwitcherService {
  constructor(private redirectService: AuthRedirectService) {}

  private identifyCurrentRelease() {
    return environment.name;
  }

  async switchToRelease(release: keyof typeof releaseUrlMap) {
    const currentRelease = this.identifyCurrentRelease();
    if (currentRelease === release) return;

    const currentRoute = window.location.pathname + window.location.search;

    const newRoute = `/release-switcher?source=${currentRelease}&route=${encodeURIComponent(
      currentRoute
    )}`;

    localStorage.setItem('target-release', release);

    return this.redirectService.redirectTo(releaseUrlMap[release], newRoute);
  }

  async checkAndRedirect() {
    const currentRelease = this.identifyCurrentRelease();
    const targetRelease = localStorage.getItem('target-release');

    if (!targetRelease) return;

    if (targetRelease === currentRelease) return;

    return this.switchToRelease(targetRelease as keyof typeof releaseUrlMap);
  }

  setCurrentReleaseAsTarget() {
    localStorage.setItem('target-release', this.identifyCurrentRelease());
  }

  setSourceRelease(source: string) {
    localStorage.setItem('source-release', source);
  }

  getSourceRelease(): string {
    return localStorage.getItem('source-release') || 'stable';
  }
}
